<template>
  <q-card flat>
    <q-card-section class="no-padding">
      <q-banner class="bg-blue text-white" inline-actions>
        {{ item.firstName }} {{ item.lastName }}
        <template v-slot:action>
          <q-btn icon="close" flat round v-close-popup/>
        </template>
      </q-banner>
    </q-card-section>
    <q-form @submit="onSubmit">
      <q-card-section>
        <div class="row">
          <div class="col-xs-12 col-md-6">
            <q-card-section class="q-gutter-xs">
              <q-input v-model="item.InternalPhone" filled label="تلفن کنفرانس کننده(اهواز)"
                       style="direction: ltr"/>
              <q-input v-model="item.InternalPhone2" filled label="تلفن کنفرانس کننده(تهران)"
                       style="direction: ltr"/>
              <q-input v-model="item.PostfixPhone" filled label="پیش شماره مرکزی تماس نوران (اهواز)"
                       style="direction: ltr"/>
              <q-input v-model="item.PostfixPhone2" filled label="پیش شماره مرکزی تماس نوران (تهران)"
                       style="direction: ltr"/>
              <q-input v-model="item.PostfixPhone3" filled label="پیش شماره مرکزی تماس نوران (صاف)"
                       style="direction: ltr"/>
            </q-card-section>
          </div>
          <div class="col-xs-12 col-md-6">
            <q-card-section class="q-gutter-xs">
              <q-input v-model="item.AvayaExt" filled label="تلفن داخلی" style="direction: ltr"/>
              <q-input v-model="item.Phone" filled label="تلفن ثابت" style="direction: ltr"/>
              <q-input v-model="item.Commission" step="any" min="0" max="5" type="number" filled
                       label="کمیسیون از فروش بر اساس هدف"
                       style="direction: ltr"/>
              <q-input v-model="item.CommissionAllSale" step="any" min="0" max="5" type="number" filled
                       label="کمیسیون از کل فروش"
                       style="direction: ltr"/>
              <q-input v-model="item.Karaneh" step="any" min="0" max="5" type="number" filled
                       label="کارانه"
                       style="direction: ltr"/>
            </q-card-section>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-md-6">
            <q-select v-model="userAccessStoreList"
                      :options="storeList"
                      label="انبارهای در دسترسی"
                      option-value="StorID"
                      option-label="StorName"
                      use-input
                      use-chips
                      multiple
                      class="q-ma-md"
                      filled/>
          </div>
          <div class="col-xs-12 col-md-6">
            <q-select v-model="issueAccessStoreList"
                      :options="storeList"
                      label="انبارهایی که قادر به صدور حواله ها از آن است"
                      option-value="StorID"
                      option-label="StorName"
                      class="q-ma-md"
                      use-input
                      use-chips
                      multiple
                      filled/>
          </div>
          <div class="row full-width">
            <div class="col-xs-12 col-md-2">
              <q-select v-model="item.IsDriver"
                        :options="driversOptions"
                        class="q-ma-md"
                        label="شناسه اتصال راننده"
                        option-value="Visitor_ID"
                        option-label="Visitor_Name"
                        use-input
                        use-chips
                        @filter="filterFn"
                        emit-value
                        map-options
                        filled/>
            </div>
            <div class="col-xs-12 col-md-2">
              <q-select v-model="item.Cs_ID"
                        :options="customersListOptions"
                        class="q-ma-md"
                        label="شناسه اتصال مشتری"
                        option-value="Cs_ID"
                        option-label="Cs_Name"
                        use-input
                        use-chips
                        @filter="filterCustomerFn"
                        emit-value
                        map-options
                        filled/>
            </div>
            <div class="col-xs-12 col-md-2">
              <q-input v-model="item.MentionID"
                       class="q-ma-md"
                       label="شناسه منشن در مایکروسافت تیمز"
                       filled/>
            </div>
            <div class="col-xs-12 col-md-2">
              <q-select v-model="item.MohasebanID"
                        :options="financeUsersOptions"
                        class="q-ma-md"
                        label="شناسه محاسبان"
                        option-value="PID"
                        option-label="FullName"
                        use-input
                        use-chips
                        @filter="filterFinanceUsers"
                        emit-value
                        map-options
                        filled/>
            </div>
          </div>
          <div class="row full-width">
            <div class="col-xs-12">
              <q-toggle v-model="item.Anbar_Recipiant_SMS"
                        label="پیغام های مرتبط با انبار را دریافت نماید"/>
              <q-space/>
              <q-toggle v-model="item.CanRecieveGoodsUnlockNotification"
                        label="پیغام های مرتبط با باز شده قفل کالا برای فروش را دریافت کند"/>
            </div>
          </div>
        </div>
      </q-card-section>
      <q-card-section>
        <div class="row full-width">
          <div class="col-xs-12 col-md-5">
            <q-input dir="ltr" v-model="item.Shaba"
                     class="q-ma-md"
                     aria-autocomplete="none"
                     label="شماره شبا"
                     fill-mask
                     unmasked-value
                     mask="IR (##) (###) (#) (####) (####) (####) (####) (##)"
                     filled>
              <template v-slot:append>
                <q-icon name="check" v-if="item.ShabaVerify && item.Shaba" round color="green">
                </q-icon>
                <q-btn v-if="!item.ShabaVerify" label="بررسی و تایید" color="indigo" text-color="white" @click="checkShaba"/>
              </template>
            </q-input>
          </div>
        </div>
      </q-card-section>
      <q-card-actions align="center">
        <q-btn label="تایید" type="submit" icon="search" color="primary"/>
        <q-btn label="انصراف" v-close-popup
               type="reset" icon="search_off" color="red" flat class="q-ml-sm"/>
      </q-card-actions>
    </q-form>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "User",
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      storeList: [],
      userAccessStoreList: [],
      issueAccessStoreList: [],
      drivers: [],
      driversOptions: [],
      customersList: [],
      customersListOptions: [],
      financeUsers: [],
      financeUsersOptions: []
    }
  },
  methods: {
    ...mapActions({
      getStoreList: 'Products/getStoreList',
      updateAdditonalUserInfo: 'Users/updateAdditonalUserInfo',
      getDriversList: 'Orders/readAvailableVisitors',
      getCustomerList: 'Customers/getSimpleCustomerList',
      getFinanceUsers: 'Users/getFinanceUsers',
      getShabaInfo: 'Finnotech/getIbanInfo',
      setShabaVerify: 'Users/setShabaVerify'
    }),
    checkShaba() {
      this.getShabaInfo(`${this.item.Shaba}`).then((res) => {
        this.$q.dialog({
          title: 'حساب به نام فرد زیر است، آیا مورد تایید می باشد؟',
          message: `${res.data.depositOwners[0].firstName} ${res.data.depositOwners[0].lastName}`,
          cancel: true,
          persistent: true
        }).onOk(() => {
          this.setShabaVerify(this.item.Users_ID).then(() => {
            this.$emit('shaba-verified', this.item)
          })
        }).onOk(() => {
          // console.log('>>>> second OK catcher')
        }).onCancel(() => {
          // console.log('>>>> Cancel')
        }).onDismiss(() => {
          // console.log('I am triggered on both OK and Cancel')
        })
      })
    },
    filterCustomerFn(val, update) {
      if (val === '') {
        update(() => {
          this.customersListOptions = this.customersList
        })
        return
      }

      update(() => {
        const needle = val.toLowerCase()
        this.customersListOptions = this.customersList.filter(v => v.Cs_Name.toLowerCase().indexOf(needle) > -1)
      })
    },
    filterFn(val, update) {
      if (val === '') {
        update(() => {
          this.driversOptions = this.drivers
        })
        return
      }

      update(() => {
        const needle = val.toLowerCase()
        this.driversOptions = this.drivers.filter(v => v.Visitor_Name.toLowerCase().indexOf(needle) > -1)
      })
    },
    filterFinanceUsers(val, update) {
      if (val === '') {
        update(() => {
          this.financeUsersOptions = this.financeUsers
        })
        return
      }

      update(() => {
        const needle = val.toLowerCase()
        this.financeUsersOptions = this.financeUsers.filter(v => v.FullName && v.FullName.indexOf(needle) > -1)
      })
    },
    onSubmit() {
      let payload = Object.assign({}, this.item)
      payload.StoreListAccess = this.userAccessStoreList && this.userAccessStoreList.length > 0 ? this.userAccessStoreList.map(item => item.StorID).join(',') : []
      payload.IssueOrderRemittanceStoreList = this.issueAccessStoreList && this.issueAccessStoreList.length > 0 ?
          this.issueAccessStoreList.map(item => item.StorID).join(',') : []
      this.updateAdditonalUserInfo(payload).then((res) => {
        if (res === 1) {
          this.$emit('user-updated', payload)
        }
      })
    }
  },
  created() {
    this.getDriversList().then((res) => {
      this.drivers = JSON.parse(res.data.visitors)
      this.driversOptions = this.drivers
    })

    this.getCustomerList().then((res) => {
      this.customersList = res
      this.customersListOptions = this.customersList
    })
    this.getStoreList().then((res) => {
      this.storeList = res
      if (this.item.StoreListAccess && this.item.StoreListAccess.length > 0) {
        this.userAccessStoreList = this.storeList.filter(item => this.item.StoreListAccess.split(',').map(item => parseInt(item)).includes(item.StorID))
      }
      if (this.item.IssueOrderRemittanceStoreList && this.item.IssueOrderRemittanceStoreList.length > 0) {
        this.issueAccessStoreList = this.storeList.filter(item => this.item.IssueOrderRemittanceStoreList.split(',').map(item => parseInt(item)).includes(item.StorID))
      }
    })

    this.getFinanceUsers().then((res) => {
      this.financeUsers = res
      this.financeUsersOptions = res
    })
  }
}
</script>

<style scoped>

</style>